import AllCardAssignContainer from './AllCardAssignContainer'

const AllCardAssign = () => {
  return (
    <div className='page-body'>
      <AllCardAssignContainer />
    </div>
  )
}

export default AllCardAssign